/** Optional leave guard (e.g. schedule builder unsaved edits). */

let leaveGuard = null;
let lastBuilderHref = "";

/**
 * Register a guard. Invoked as `guard(proceed, onBlocked)`.
 * - Call `proceed()` to continue the navigation.
 * - If blocked for confirmation, call `onBlocked?.()` first (e.g. restore URL after popstate).
 * @returns {() => void} unregister
 */
export function setLeaveGuard(fn) {
  leaveGuard = typeof fn === "function" ? fn : null;
  return () => {
    if (leaveGuard === fn) leaveGuard = null;
  };
}

/** Run `proceed` now, or ask the active guard first. */
export function runWithLeaveGuard(proceed, onBlocked) {
  if (typeof proceed !== "function") return;
  if (!leaveGuard) {
    proceed();
    return;
  }
  leaveGuard(proceed, onBlocked);
}

export function noteBuilderHref(href) {
  const next = String(href || "").trim();
  if (next) lastBuilderHref = next;
}

export function getBuilderHref() {
  return lastBuilderHref;
}
